<template>
<div class="row">
  <div class="col-xs-12">
    <h5>Tags</h5>
    <div
      v-for="(categorie, categorieIndex) in categories"
      :key="categorie._id"
      style="padding-left: 15px;"
      class="form-group"
    >
      <div class="row-radio">
        <div class="col-radio">
          <label>{{ categorie.name }}: </label>
        </div>
        <div class="col-radio">
          <div class="row-radio">
            <div
              v-for="(tag, index) in tagsByCategories[categorie._id]"
              :key="tag._id"
              class="col-radio"
            >
              <div class="row-radio">
                <div class="col-radio">
                  <div class="row-radio row-radio-border">
                    <div class="col-radio">
                      <input
                        :value="tag"
                        @input="$emit('change', {tag: tag._id, categorie: categorie._id})"
                        type="checkbox"
                      >
                    </div>
                    <div class="col-radio">
                      {{ tag.name }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'list-categories-tags',

  computed: {
    ...mapGetters('tags', [
      'tagsByCategories'
    ]),
    ...mapGetters('categories', [
      'categories',
      'filtersTags'
    ])
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Trg/Tags/InputCategoriesTags.vue